<template>
  <svg :width="size" :height="size" class="pie-chart">
    <circle ref="pie" :r="radius" :cx="radius * 2" :cy="radius * 2" class="pie" />
    <circle
      :r="radius * 2"
      :cx="radius * 2"
      :cy="radius * 2"
      stroke="black"
      stroke-width="2"
      fill="none"
      class="outline"
    />
  </svg>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, watch } from "vue";

const props = defineProps<{
  size: number;
  percent: number;
}>();

const pie = ref<HTMLElement>();

const radius = computed(() => {
  return props.size / 4;
});

function createPie(): void {
  const circumference = 2 * Math.PI * radius.value;
  const chordLength = (props.percent / 100) * circumference;
  const strokeWidth = radius.value * 2;
  const pieElement = pie.value as HTMLElement;
  pieElement.style.strokeDasharray = `${chordLength} ${circumference}`;
  pieElement.style["stroke-width"] = strokeWidth;
  pieElement.style.stroke = props.percent > 0 ? "" : "white";
}

onMounted(() => createPie());

watch(props, createPie);
</script>

<style lang="less" scoped>
@innovator-color: rgb(109, 200, 191);

circle.pie {
  fill: #ffffff;
  stroke: @innovator-color;
  stroke-width: 50;
  stroke-dasharray: 0 158;
  transition: stroke-dasharray 0.3s ease;
}

circle.outline {
  stroke: gray;
  stroke-width: 3;
}

svg {
  margin: 0 auto;
  transform: rotate(-90deg);
  background: #ffffff;
  border-radius: 50%;
  display: block;
}
</style>
